export default {
  search: {
    mdm: "Materials Master",
  },
  warning: {
    coincidence: "You have a high coincidence in one of your materials",
    stockcode: "Stock code",
    continue: "Close",
    see: "See Material",
    continuing: "You can use a material as a template by selecting one from the list",
  },
  searchTitle: "Search",
  useAsTemplate: "Use as template",
  clearSelection: "Clear selection",
  useWithOutATemplate: "Create material without a template",
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/CAT4MRO/search.js